<template>
<v-card flat class="grey lighten-4" >
  <!-- <v-card-title class='subtitle-1 overline' >
  </v-card-title> -->

  <v-card-title class="overline grey lighten-4 py-1" >Choose a space:</v-card-title>
  <space-picker chips owner-required
    v-if="space || !fixedSpace"
    v-model="space"
    :multiple="false" />

  <template v-if="space" >

    <v-card-title class="overline grey lighten-4 py-1" >Choose practitioners:</v-card-title>
    <v-chip-group column
      :multiple="multiplePractitioners"
      active-class="primary"
      class="mx-4"
      v-model="practitioners" >
      <template v-for='member in getMembers(space)' >
        <!-- <pre v-text="member" :key="member.id" /> -->
        <v-chip small
          :key='member.id'
          :value='member' >{{member.full_name}}</v-chip>
      </template>
    </v-chip-group>

    <template v-if="practitioners && practitioners.length > 0" >
      <v-card-title class="overline grey lighten-4 py-1" >Choose appointment types:</v-card-title>
      <v-card-text row wrap class="pb-5" >

        <v-col
          v-for="practitioner in practitioners"
          :key="practitioner.id" >
          <v-card height="100%" >
            <v-card-title class='overline' >
              {{practitioner.full_name}}
            </v-card-title>
            <product-picker chips
              class="ml-4"
              v-model='products'
              :space-id='space'
              :multiple="multiple"
              :practitioner-id="practitioner.id"
              :with-location-filter='false'
              :return-object='returnObject' >
            </product-picker>
          </v-card>
        </v-col>

      </v-card-text>
    </template>
  </template>
</v-card>
</template>

<script>
import SpacePicker from '@/components/pickers/SpacePicker.vue'
import ProductPicker from '@/components/pickers/ProductPicker.vue'
// import LocationPicker from '@/components/pickers/LocationPicker.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'HierarchicalPicker',
  components: {
    SpacePicker,
    ProductPicker
    // LocationPicker
  },
  props: {
    // one of or more of: space, location, practitioner, product, hours
    targets: { type: Array },
    spaceId: { type: Number, required: false },
    practitionerId: { type: Number, required: false },
    multiplePractitioners: { type: Boolean, default: true },
    multiple: { type: Boolean, default: false },
    fixedSpace: { type: Boolean, default: false },
    returnObject: { type: Boolean, default: false }
  },
  data () {
    return {
      space: null,
      products: null,
      practitioners: []
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        if (this.spaceId) { this.space = this.spaceId }
        this.$emit('update:spaceId', this.spaceId)
      }
    },
    space () {
      this.practitioners = []
      this.products = null
    },
    products () {
      this.$emit('update:products', this.products)
    },
    practitioners () {
      this.$emit('update:practitioners', this.practitioners)
      this.products = null
    }
  },
  computed: {
    ...mapGetters ('identity', ['meId', 'getMembers']),
  }
}
</script>
